export const HOME = {
  emergentLink: "home-emergent-link",
  hero: "home-hero",
  ctaBook: "home-cta-book",
  ctaMenu: "home-cta-menu",
  menuSection: "home-menu-section",
  bookingSection: "home-booking-section",
  ownerAccessLink: "footer-owner-access-link",
  accessCodeInput: "access-code-input",
  accessCodeSubmit: "access-code-submit",
};

export const BOOKING = {
  form: "booking-form",
  name: "booking-name",
  email: "booking-email",
  phone: "booking-phone",
  date: "booking-date",
  eventType: "booking-event-type",
  guests: "booking-guests",
  flavors: "booking-flavors",
  notes: "booking-notes",
  treatCakes: "booking-treat-cakes",
  treatCupcakes: "booking-treat-cupcakes",
  treatCookies: "booking-treat-cookies",
  treatBrownies: "booking-treat-brownies",
  treatCakePops: "booking-treat-cake-pops",
  treatMiniCakes: "booking-treat-mini-cakes",
  submit: "booking-submit",
  payDeposit: "booking-pay-deposit",
  skipDeposit: "booking-skip-deposit",
};

export const ADMIN = {
  page: "admin-page",
  logout: "admin-logout",
  tabBookings: "admin-tab-bookings",
  tabMenu: "admin-tab-menu",
  tabSettings: "admin-tab-settings",
  addMenuBtn: "admin-add-menu-btn",
  saveConfigBtn: "admin-save-config-btn",
  menuItemRow: "admin-menu-item",
  bookingRow: "admin-booking-row",
};
